import React, { useState, useEffect, useRef } from 'react'

export interface TriggerProps {
  onClick?: () => void;
  active?: boolean;
  innerRef: any;
}

export interface DropdownTriggerProps {
  onClick?: () => void;
  children: React.ReactElement<TriggerProps>;
  dropdown: React.ReactNode;
}

export const DropdownTrigger: React.FC<DropdownTriggerProps> = ({
  onClick = () => {},
  children,
  dropdown
}) => {
  const dropdownRef = useRef(null)
  const triggerRef = useRef(null)
  const [isActive, setIsActive] = useManageDropdown(triggerRef, dropdownRef, false)

  const handleOnClick = () => {
    onClick()

    setIsActive(!isActive)
  }

  return (
    <div className='ch-c-dropdown-trigger ch-u-position--relative ds-u-display--inline-block'>
      {React.cloneElement(children, {
        onClick: handleOnClick,
        active: isActive,
        innerRef: triggerRef
      })}
      {isActive ? (
        <>
          <div className='ch-c-up-arrow' />
          <div className='ch-c-dropdown-menu__container' ref={dropdownRef}>
            {dropdown}
          </div>
        </>
      ) : null}
    </div>
  )
}

const useManageDropdown = (trigger: any, dropdown: any, initialState: any) => {
  const [isActive, setIsActive] = useState(initialState)

  useEffect(() => {
    const pageClickEvent = (e: Event) => {
      // If the active element exists and is clicked outside of
      if (dropdown.current !== null && !dropdown.current.contains(e.target)) {
        setIsActive(false)
      }
    }

    const keyPressEvent = (e: any) => {
      if (e.key === 'Escape') {
        setIsActive(false)

        if (trigger.current) trigger.current.focus()
      }
    }

    if (isActive) {
      window.addEventListener('click', pageClickEvent)
      window.addEventListener('keydown', keyPressEvent)
    }

    return () => {
      window.removeEventListener('click', pageClickEvent)
      window.removeEventListener('keydown', keyPressEvent)
    }
  }, [isActive, dropdown, trigger])

  return [isActive, setIsActive]
}
